import { UserRole } from '../types';

type LegacyRole = 'student' | 'instructor' | 'admin' | string;

/**
 * Maps legacy role strings to CASL UserRole
 * Adjust this mapping based on your backend role structure
 */
export const mapLegacyRoleToUserRole = (legacyRole: LegacyRole): UserRole => {
  const roleMap: Record<string, UserRole> = {
    student: 'student',
    instructor: 'professor', // Map instructor to professor
    admin: 'platform_admin', // Map admin to platform_admin
    super_admin: 'super_admin',
    platform_admin: 'platform_admin',
    professor: 'professor',
    transcript_evaluator: 'transcript_evaluator',
    counselor: 'counselor',
  };

  return (legacyRole && roleMap[legacyRole.toLowerCase()]) || 'student';
};

/**
 * Check if user has super admin role
 */
export const isSuperAdmin = (role: UserRole): boolean => {
  return role === 'super_admin';
};

/**
 * Check if user has platform admin role
 */
export const isPlatformAdmin = (role: UserRole): boolean => {
  return role === 'platform_admin';
};

/**
 * Check if user has professor role
 */
export const isProfessor = (role: UserRole): boolean => {
  return role === 'professor';
};

/**
 * Check if user has transcript evaluator role
 */
export const isTranscriptEvaluator = (role: UserRole): boolean => {
  return role === 'transcript_evaluator';
};

/**
 * Check if user has counselor role
 */
export const isCounselor = (role: UserRole): boolean => {
  return role === 'counselor';
};

/**
 * Check if user has student role
 */
export const isStudent = (role: UserRole): boolean => {
  return role === 'student';
};

/**
 * Check if user has any admin role (super or platform)
 */
export const isAnyAdmin = (role: UserRole): boolean => {
  return role === 'super_admin' || role === 'platform_admin';
};
